import commonSlice from '../common';
import { principlesSlice } from './principles';
import { timelineSlice } from './timeline';

const PRISMIC_TO_PARSER_SLICE = {
  ...commonSlice,
  principles: principlesSlice,
  timeline: timelineSlice,
};

export default PRISMIC_TO_PARSER_SLICE;
